import { Form, FormikProvider, useFormik } from "formik";
import React, { useState } from "react";
import { z } from "zod";
import { submitHelper, validateFormikWithZodSchema } from "@helpers/form";
import { simulatePlaidError } from "@lib/simulations";
import { createFormikFields } from "@components/forms/fields/createFormikFields";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { VStack } from "@design-system/VStack/VStack";

const simulatePlaidErrorFormSchema = z.object({
    ownerEmail: z.string().email("Invalid email").min(1, "E-mail is required"),
});

type SimulatePlaidErrorFormValues = z.infer<
    typeof simulatePlaidErrorFormSchema
>;

const fields = createFormikFields<SimulatePlaidErrorFormValues>();

export const SimulatePlaidAccountError: React.FC = () => {
    const [loading, setLoading] = useState(false);

    const formik = useFormik<SimulatePlaidErrorFormValues>({
        initialValues: {
            ownerEmail: "",
        },
        validate: validateFormikWithZodSchema(simulatePlaidErrorFormSchema),
        onSubmit: submitHelper({
            loading,
            setLoading,
            handler: async (body, { resetForm }) => {
                await simulatePlaidError(body);
                resetForm();
            },
        }),
    });

    return (
        <section>
            <h3>Plaid Account Error</h3>

            <FormikProvider value={formik}>
                <Form>
                    <VStack gap={16} align="start">
                        <fields.Text
                            name="ownerEmail"
                            label="Owner E-mail"
                            size="xl"
                        />
                        <ButtonWithLoader
                            loading={loading}
                            type="submit"
                            variant="primary"
                            size="md"
                        >
                            Submit
                        </ButtonWithLoader>
                    </VStack>
                </Form>
            </FormikProvider>
        </section>
    );
};
